import './person-category-new-modal.tag'
riot.tag2('persons-category-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Группы контактов</div>\n    </yield>\n    <yield to="body">\n      <catalog object="ContactCategory" cols="{parent.cols}" add="{parent.add}" remove="{parent.remove}" dblclick="{parent.opts.submit.bind(this)}" disable-col-select="true" writedc="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _this2 = this;

var self = this;

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];

self.collection = "ContactCategory";
self.remove = function (e, items) {
    var self = _this2,
        params = { ids: items };

    modals.create('bs-alert', {
        type: 'modal-danger',
        title: 'Предупреждение',
        text: items.length > 1 ? 'Вы точно хотите удалить эти записи?' : 'Вы точно хотите удалить эту запись?',
        size: 'modal-sm',
        buttons: [{ action: 'yes', title: 'Удалить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
        callback: function callback(action) {
            if (action === 'yes') {
                API.request({
                    object: self.collection,
                    method: 'Delete',
                    data: params,
                    success: function success(response) {
                        popups.create({ title: 'Успешно удалено!', style: 'popup-success' });
                        self.tags['bs-modal'].tags.catalog.reload();
                    }
                });
            }
            this.modalHide();
        }
    });
};

self.add = function () {
    modals.create('person-category-new-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            var params = { name: _this.name.value };
            API.request({
                object: 'ContactCategory',
                method: 'Save',
                data: params,
                success: function success(response, xhr) {
                    popups.create({ title: 'Успех!', text: 'Группа добавлена!', style: 'popup-success' });
                    _this.modalHide();
                    self.tags['bs-modal'].tags.catalog.reload();
                }
            });
        }
    });
};
});


// WEBPACK FOOTER //
// ./pages/persons/persons-category-select-modal.tag